// Text controls of the admin template editor: the same panel customers get in the website editor
// (components/studio/PropertiesPanel.js), so every option there (letter spacing, italic, outline,
// shadow, label background, highlight, transparency, rotation, glyphs, ...) can be set on a template
// field (Ezriel, 2026-10-12). The studio edits `text`; a template field's wording is `default_text`.
import { useRef } from 'react';
import { TextProperties } from '../studio/PropertiesPanel';
import { GlyphsPanel } from '../studio/panels/GlyphsPanel';

export const TemplateFieldStyle = ({ field, fonts, onPatch, onAddOrnament }) => {
  const caretRef = useRef(null); // { id, start, end } in the wording box, for glyph insertion
  const text = field.default_text ?? '';
  const studioField = { ...field, text };

  const patch = (changes) => {
    const { text: wording, ...rest } = changes;
    onPatch(wording === undefined ? rest : { ...rest, default_text: wording });
  };

  // Same font: type the glyph into this field at the cursor. Another font: a new fixed ornament field.
  const insertGlyph = (ch, family) => {
    if (family !== field.font_family) {
      onAddOrnament(ch, family);
      return;
    }
    const caret = caretRef.current?.id === field.id ? caretRef.current : { start: text.length, end: text.length };
    patch({ text: text.slice(0, caret.start) + ch + text.slice(caret.end) });
    caretRef.current = { id: field.id, start: caret.start + ch.length, end: caret.start + ch.length };
  };

  const glyphs = (
    <GlyphsPanel
      heading={false}
      fonts={fonts}
      defaultFamily={field.font_family}
      selectedFamily={field.font_family}
      onInsert={insertGlyph}
      targetLabel={field.label || 'Text'}
    />
  );

  return (
    <TextProperties
      field={studioField}
      fonts={fonts}
      onPatch={patch}
      onCaret={(id, start, end) => {
        caretRef.current = { id, start, end };
      }}
      glyphs={glyphs}
    />
  );
};

export default TemplateFieldStyle;
